import React from "react";
import AdminHeader from "../../../components/admin/AdminHeader";
import { AdminFooter } from "../../../components/admin/AdminFooter";
import AdminPromptsPageEdit from "../../../views/admin/prompts";
import AdminPromptsList from "../../../views/admin/prompts/list";

const AdminPromptsPageList = () => {
  window.scrollTo(0, 0);

  return (
    <div>
      <AdminHeader />
        <AdminPromptsList />
      <AdminFooter />
    </div>
  );
};

export default AdminPromptsPageList;
